import { Text, View } from '@react-pdf/renderer';

import { styles } from '@/components/Contract/Download/style';

const Communication = () => {
  return (
    <View style={styles.section}>
      <Text style={styles.title}>Communications with Buyer and/or Seller</Text>
      <Text style={styles.list}>
        <Text style={styles.listItem}>
          Wherever this Agreement contains a provision that requires or allows
          communication/delivery to a Buyer, those provisions may be satisfied
          only by communication/delivery being made directly to the Buyer,
          unless otherwise agreed to by the parties. Wherever this Agreement
          contains a provision that requires or allows communication/delivery to
          a Seller, that provision shall be satisfied by communication/delivery
          to the Broker for Seller, if any. If there is no Broker for Seller,
          those provisions may be satisfied only by communication/delivery being
          made directly to the Seller, unless otherwise agreed to by the
          parties.
        </Text>
        <Text style={styles.listItem}>
          Headings: The section and paragraph headings in this Agreement are for
          convenience only and are not intended to indicate all of the matter in
          the sections which follow them. They shall have no effect whatsoever
          in determining the rights, obligations or intent of the parties.
        </Text>
      </Text>
    </View>
  );
};

export default Communication;
